export default __webpack_public_path__ + "static/media/88.06cf99db.jpg";